import React, { useEffect, memo } from 'react';
import styled from 'styled-components';
import Name from 'components/Name';
import Price from 'components/Price';
import StarRating from 'components/RatingsAndReviews/StarRating';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import { ProductDetailsProps } from './ProductDetailsProps';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const ProductDetails = memo((props: ProductDetailsProps) => {
  const { brand, name, price, reviewTotal, reviewStars, productId } = props;
  const { selectedSku } = useSelectedSkuContext();

  useEffect(() => {
    if (productId) {
      document.querySelector('#product-detail')?.setAttribute('data-cnstrc-item-id', productId);
    }
  }, []);

  return (
    <Container
      data-testid="product-details"
      id="product-detail"
      data-cnstrc-product-detail
      data-cnstrc-item-name={name}
      data-cnstrc-item-price={price?.decimal}
      data-cnstrc-item-variation-id={selectedSku?.option}
    >
      <Name brand={brand} name={name} />
      <Price price={price} />

      {reviewTotal && reviewStars && reviewTotal > 0 && (
        <StarRating reviewTotal={reviewTotal} reviewStars={reviewStars} />
      )}
    </Container>
  );
});

export default ProductDetails;
